import { GlobalResponseObject } from "../../global-response-object";
import { TotalSubCategoryActBudRevenue } from "./totalSubCatWiseActBudgetRevDetails";

export class TotalSubCatWiseActBudgetRevResponse extends GlobalResponseObject{
data?:TotalSubCategoryActBudRevenue[];
constructor(status: boolean, intlCode: number, internalMessage: string, data?:TotalSubCategoryActBudRevenue[]){
    super(status,intlCode,internalMessage)
    this.data = data;
}
}